import { createContext } from "react";

const SearchContext = createContext();

export default SearchContext;
